/* Hollin - shared MB-style UI behaviour: drawer, header solid state, reveals */
(function(){
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Drawer */
  var drawer = document.getElementById('mbdrawer');
  function openDrawer(){ if(drawer){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); } }
  function closeDrawer(){ if(drawer){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); } }
  document.querySelectorAll('[data-menu-open]').forEach(function(b){ b.addEventListener('click', openDrawer); });
  if(drawer){
    drawer.querySelector('.mbdrawer__back').addEventListener('click', closeDrawer);
    drawer.querySelector('.mbdrawer__close').addEventListener('click', closeDrawer);
    drawer.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeDrawer); });
    addEventListener('keydown', function(e){ if(e.key==='Escape') closeDrawer(); });
  }

  /* Arrivee sur une ancre depuis une autre page : se recaler une fois la page chargee */
  if(location.hash){
    addEventListener('load', function(){
      var t = document.getElementById(location.hash.slice(1));
      if(t) t.scrollIntoView();
    });
  }

  /* Header solid on scroll */
  var hdr = document.querySelector('.mbhdr');
  if(hdr){
    addEventListener('scroll', function(){ hdr.classList.toggle('is-solid', scrollY>60); }, {passive:true});
  }

  /* Icones d'en-tete : compte et recherche menent a leur page sur tout le site */
  document.querySelectorAll('button[aria-label="Account"]').forEach(function(b){
    b.addEventListener('click', function(){ location.href = '/account'; });
  });
  document.querySelectorAll('button[aria-label="Search"]').forEach(function(b){
    b.addEventListener('click', function(){ location.href = '/search'; });
  });

  /* Panier : les fiches produit ont leur tiroir (#pcart) ; ailleurs on ajoute un tiroir vide */
  if(!document.getElementById('pcart')){
    var cart = document.createElement('div');
    cart.className = 'mbcart'; cart.setAttribute('aria-hidden', 'true');
    cart.innerHTML = '<div class="mbcart__back"></div><aside class="mbcart__panel" role="dialog" aria-modal="true" aria-label="Your basket">' +
      '<div class="mbcart__top"><h3>Your basket</h3><button class="mbcart__close" aria-label="Close basket"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<p class="mbcart__empty">Your basket is empty.</p><a class="mbcart__cta" href="/collections/all">Browse all products</a></aside>';
    document.body.appendChild(cart);
    var lastCartBtn = null;
    var openCart = function(e){ lastCartBtn = e.currentTarget; cart.classList.add('is-open'); cart.setAttribute('aria-hidden', 'false'); cart.querySelector('.mbcart__close').focus(); };
    var closeCart = function(){ cart.classList.remove('is-open'); cart.setAttribute('aria-hidden', 'true'); if(lastCartBtn) lastCartBtn.focus(); };
    document.querySelectorAll('button[aria-label="Basket"]').forEach(function(b){ b.addEventListener('click', openCart); });
    cart.querySelector('.mbcart__back').addEventListener('click', closeCart);
    cart.querySelector('.mbcart__close').addEventListener('click', closeCart);
    addEventListener('keydown', function(e){ if(e.key === 'Escape' && cart.classList.contains('is-open')) closeCart(); });
  }

  /* Reveals */
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('rv-in'); io.unobserve(e.target); } });
  }, {rootMargin:'0px 0px -8% 0px', threshold:.05});
  document.querySelectorAll('[data-rv]').forEach(function(el){
    if(reduced){ el.classList.add('rv-in'); return; }
    var r = el.getBoundingClientRect();
    if(r.top < innerHeight*.95 && r.bottom > 0){
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ el.classList.add('rv-in'); }); });
    } else { io.observe(el); }
  });
})();
